import { ReactNode } from "react";
import { useParams } from "react-router";

import useMeGetProjectInfoQuery from "../api/useMeGetProjectInfoQuery";
import ProjectContext from "./ProjectContext";

function ProjectContextProvider({ projectSlug, children }: { projectSlug: string; children: ReactNode }) {
    const { data, loading, error } = useMeGetProjectInfoQuery(projectSlug);
    return (
        <ProjectContext.Provider
            value={{
                loading,
                error,
                data,
            }}
        >
            {children}
        </ProjectContext.Provider>
    );
}

export default function ProjectContextProviderWrapper({ children }: { children: ReactNode }) {
    const { projectSlug } = useParams();

    if (projectSlug) {
        return <ProjectContextProvider projectSlug={projectSlug}>{children}</ProjectContextProvider>;
    }
    return children;
}
